import store from "@/store";

export default {
  namespaced: true,
  camera_proxy: {
    title: "camera proxy | cameras proxy",
    id: "camera proxy id",
    rtsp_available: "Enabled RTSP flow",
    last_connection: "last connection",
    assigned: "assigned",
    rec_mode: "recording mode",
    rec_hours: "recording days",
    days: "Days",
    limit: {
      "3_days": "3 days",
      "7_days": "7 days",
      "14_days": "14 days",
      "30_days": "30 days",
      "60_days": "60 days",
      "90_days": "90 days",
      "180_days": "180 days",
      "1_year": "1 year",
      "2_years": "2 years",
      "custom": "Custom"
    },
    recording_enable: "recording enable",
    on_demand: "video on demand enable",
    vbr_quality: "VBR quality",
    frame_rate: "Frame rate",
    resolution: "Resolution",
    store:{
      space_200_gb: "200 GB",
      space_500_gb: "500 GB",
      space_1_tb: "1 TB",
    },
    profile: "profile",
    encoding: "encoding",
    resolution: "resolution",
    frame_rate: "frame rate",
    bitrate: "bitrate",
    vbr: "vbr",
    quality: "quality",
    gov: "gov",
    send_to_seproban: "Send to seproban"
  },
};
